module.exports = __webpack_public_path__ + "static/media/business-meeting.8fcb844b.jpg";